import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { LifeBuoy, Send } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../api';

export default function SupportModal({ open, onClose }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    reason: 'Soporte Técnico',
    contact: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.message) return toast.error('Por favor, describí tu consulta');
    
    setLoading(true);
    try {
      await api.post('/support/ticket', formData);
      toast.success('¡Mensaje enviado! Facu revisará tu consulta pronto.');
      onClose();
      setFormData({ reason: 'Soporte Técnico', contact: '', message: '' });
    } catch (err) {
      toast.error('Error al enviar. Intentá de nuevo o escribinos a soporte@dinamiclassapp.com.ar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-lg text-white shadow-2xl p-0 overflow-hidden">
        
        {/* Cabecera Azul */}
        <div className="bg-blue-600 p-6 flex items-center gap-4">
            <div className="bg-white/20 p-3 rounded-2xl">
                <LifeBuoy size={32} className="text-white" />
            </div>
            {/* Agregado DialogHeader para semántica de accesibilidad (aria-describedby) */}
            <DialogHeader className="text-left">
                <DialogTitle className="text-xl font-bold text-white">Centro de Ayuda</DialogTitle>
                <DialogDescription className="text-blue-100 text-sm mt-1">
                    ¿En qué podemos potenciarte hoy?
                </DialogDescription>
            </DialogHeader>
        </div>

        {/* Cuerpo del Formulario */}
        <div className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Selector de Motivo */}
                <div className="space-y-2">
                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Motivo</label>
                <select 
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-sm focus:border-blue-500 outline-none transition-all cursor-pointer"
                    value={formData.reason}
                    onChange={(e) => setFormData({...formData, reason: e.target.value})}
                >
                    <option>Soporte Técnico</option>
                    <option>Sugerencia</option>
                    <option>Consulta de Pago</option>
                    <option>Consultas Varias</option>
                </select>
                </div>
                
                {/* Campo de Contacto Alternativo */}
                <div className="space-y-2">
                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Tu WhatsApp o Mail</label>
                <input 
                    placeholder="Ej: +54 3764..."
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-sm focus:border-blue-500 outline-none transition-all"
                    value={formData.contact}
                    onChange={(e) => setFormData({...formData, contact: e.target.value})}
                />
                </div>
            </div>

            {/* Área del Mensaje */}
            <div className="space-y-2">
                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Mensaje / Detalle</label>
                <textarea 
                rows={4}
                placeholder="Hola Facu, tengo una idea para..."
                className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-sm focus:border-blue-500 outline-none resize-none transition-all"
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                />
            </div>

            {/* Botón de Enviar */}
            <button 
                type="submit"
                disabled={loading}
                className="w-full bg-blue-600 hover:bg-blue-700 py-4 rounded-xl font-bold transition-all flex items-center justify-center gap-2 shadow-lg shadow-blue-900/20 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {loading ? "Enviando mensaje..." : <><Send size={18}/> Enviar consulta</>}
            </button>
            </form>
        </div>
      </DialogContent>
    </Dialog>
  );
}
